import { AccessType } from '~/types'
import { accessToken } from './access-token'

export const downloadPdf = async (
  url: string,
  filename: string,
  accessType: AccessType = 'dashboard',
) => {
  const token = accessToken.get(accessType)
  if (!token) {
    throw new Error(`Missing access token for access type: ${accessType}`)
  }

  const response = await fetch(url, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
  if (!response.ok) {
    throw new Error(`Failed to download PDF (${response.status})`)
  }
  const blob = await response.blob()
  const pdfBlob = new Blob([blob], {
    type: 'application/pdf',
  })

  // TODO: used workaround (window.navigator as any) since msSaveOrOpenBlob doesn't exist
  if ((window.navigator as any).msSaveOrOpenBlob) {
    ;(window.navigator as any).msSaveOrOpenBlob(pdfBlob, filename)
  } else {
    const url = window.URL.createObjectURL(pdfBlob)
    const a = document.createElement('a')
    a.style.display = 'none'
    a.href = url
    a.download = filename
    document.body.appendChild(a)
    a.click()
    setTimeout(() => {
      window.URL.revokeObjectURL(url)
    }, 250)
  }
}
